<template>
  <div class="w-full py-2">
    <gd-dropdown
      v-model="dropdownValue"
      :options="dropdownOptions"
      dark
      size="full"
      class="mb-2"
    ></gd-dropdown>
    <gd-slider
      v-if="showSlider"
      v-model="sliderValue"
      class="mb-2"
      min="0"
      :max="sliderMax"
      step="1"
      dark
      :readonly="false"
    />
  </div>
</template>
<script>
import GdSlider from './Slider';
import GdDropdown from './Dropdown';

export default {
  name: 'DropdownSliderPanel',
  components: { GdSlider, GdDropdown },
  props: ['value', 'options'],
  computed: {
    dropdownOptions() {
      return Object.keys(this.options);
    },
    dropdownValue: {
      get() {
        let value = null;
        const unit = this.value ? this.value.replace(/[^a-z%]/gi, '') : 'Parent default';
        for (const option of this.dropdownOptions) {
          if (option?.toLowerCase()?.includes(unit?.toLowerCase())) {
            value = option;
            break;
          }
        }
        return value;
      },
      set(value) {
        if (typeof this.options[value] === 'object') {
          if(value.includes('%')){
            this.$emit('input', this.options[value][100]);
            this.$emit('change', this.options[value][100]);
          }
          else{
            this.$emit('input', this.options[value][1024]);
            this.$emit('change', this.options[value][1024]);
          }
        } else {
          this.$emit('input', this.options[value]);
          this.$emit('change', this.options[value]);
        }
      },
    },
    showSlider() {
      return typeof this.options[this.dropdownValue] === 'object';
    },
    sliderMax() {
      return this.options[this.dropdownValue].length - 1;
    },
    sliderValue: {
      get() {
        const value = parseFloat(this.value.replace(/[^0-9.]/gi, ''));
        return value > this.sliderMax
          ? this.sliderMax
          : this.options[this.dropdownValue].indexOf(this.value);
      },
      set(value) {
        this.$emit('input', this.options[this.dropdownValue][value]);
        this.$emit('change', this.options[this.dropdownValue][value]);
      },
    },
  },
};
</script>
